/* global customElements */

// Import the LitElement base class and html helper function
import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';

// Extend the LitElement base class
//@customElement('my-element')
class MyElement extends LitElement {

	static get properties() {
	  return { 
		foo: { type: String }
	  };
	}

	constructor() {
		super();
		this.foo = 'foo';
	}
  
  /**
   * Implement `render` to define a template for your element.
   *
   * You must provide an implementation of `render` for any element
   * that uses LitElement as a base class.
   */
  render(){
    /**
     * `render` must return a lit-html `TemplateResult`.
     *
     * To create a `TemplateResult`, tag a JavaScript template literal
     * with the `html` helper function:
     */
    return html`
      <!-- template content -->
      <vaadin-button @click="${this.clickHandler}"> My Button </vaadin-button>
    `;	
  }
  clickHandler() { 
	  alert('test');
  }
  
  
};

// Register the new element with the browser.
customElements.define('my-element', MyElement);


